import {initVessel, showImg, showFleets, showVessels, setBlocked , hideAll, hasFleets, setSelectFleet, fleetHasVessels, setSelectedVessel, vesselHasImage} from './helpers'

const state = {
    show: {fleets:false, vessels: false, form: false, img:false, settings: false},
    selected: {fleet: {}, fleetIndex: 0, vessel: {}, vesselIndex: 0},
    fleets: [],
    emptyForm: {status: 1, name: "", fleet_id: 0,  type: 1,  grt: "", main_engine: "",engine_type: "",built_year: "" , nationalites: [], trading_area: "", flag: [], shipowner: "" , wifi: "" },
    isLoaded: false,
    countries: [],
    vesselsType: [],
    isBlocked: false,
}

const getters = {
    isLoaded: state => state.isLoaded,
    isBlocked: state => state.isBlocked,
    fleets: state=>state.fleets,
    selected: state => state.selected,
    countries: state => state.countries,
    vesselsType: state=> state.vesselsType,
    show: state=>state.show
 }

const mutations = {
    setCountries: (state, payload) => state.countries = payload,
    setFleets: (state, payload) => {
        state.fleets = payload;
        if(hasFleets(state)) {
            setSelectFleet(state, 0);
            showFleets(state, true);
            if(fleetHasVessels(state)) {
                initVessel(state, 0);
            }
        }
    },
    selectFleet: (state, payload) => {
        hideAll(state);
         setSelectFleet(state, payload);
         showFleets(state, true);
        if(fleetHasVessels(state)) {
            initVessel(state, 0);
        }

    },
    selectVessel: (state,payload) => {
        hideAll(state);
        showFleets(state, true);
        if(fleetHasVessels(state)) {
            initVessel(state, payload);
        }
    },

    setImg: (state, payload) => {
        state.selected.vessel.images = [];
        state.selected.vessel.images.push({name: payload.path});
        showImg(state, true);
    }
};

const actions = {
    setCountries: ({commit}, payload) => commit('setCountries', payload),
    setFleets: ({commit}, payload) => commit('setFleets', payload),
    selectFleet: ({commit}, payload) => commit('selectFleet', payload),
    selectVessel: ({commit}, payload) => commit('selectVessel', payload),
};


export default {
    state, getters, mutations, actions
}


// WEBPACK FOOTER //
// ./vue/fleet/store/modules/fleet.js